import script from "./BaseSelectDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSelectDropdown.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__